import React from "react";
import { useAuth } from "../contexts/AuthContext";

const WelcomeSection: React.FC = () => {
  const { user, isAuthenticated } = useAuth();

  // Get display name - prefer name over username, fallback to username
  const getDisplayName = () => {
    if (!user) return "Officer";
    
    // If user has a proper name (not just username), use it
    if (user.name && user.name !== user.username && user.name.trim() !== '') {
      return user.name;
    }
    
    // Otherwise use username
    return user.username;
  };

  return (
    <div className="px-6 py-6">
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-[1.27rem] md:text-4xl font-bold text-white mb-2">
            {isAuthenticated ? `Welcome, ${getDisplayName()}` : "Welcome to Command Legacy"}
          </h2>
          <p className="text-gray-300 text-sm md:text-base opacity-80">
            {isAuthenticated 
              ? "Access your professional law enforcement resources"
              : "Sign in to access your professional law enforcement resources"
            }
          </p>
        </div>
        
        {isAuthenticated && user && (
          <div className="flex items-center space-x-3">
            {user.avatar_url && (
              <img 
                src={user.avatar_url} 
                alt={user.name || user.username}
                className="w-10 h-10 rounded-full border-2 border-white"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeSection;
